// action - account reducer firebase
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";

// action admin - Login in MERN
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";

//user get details
export const GET_ALL_User = "GET_ALL_User";
export const GET_USER_DETAILS = "GET_USER_DETAILS";

export const GET_ALL_STAFF = "GET_ALL_STAFF";
export const GET_STAFF_DETAILS = "GET_STAFF_DETAILS";

export const GET_ALL_PROPERTIES = "GET_ALL_PROPERTIES";
export const GET_PROPERTY_DETAILS = "GET_PROPERTY_DETAILS";
export const GET_APPLIED_USERS_FOR_PROPERTY = "GET_APPLIED_USERS_FOR_PROPERTY";

export const GET_ALL_PROPERTIES_REQUEST = "GET_ALL_PROPERTIES_REQUEST";
export const GET_PROPERTY_REQUEST_DETAILS = "GET_PROPERTY_REQUEST_DETAILS";
export const GET_ALL_PROPERTIES_REQUEST_CHAT =
  "GET_ALL_PROPERTIES_REQUEST_CHAT";

export const GET_ALL_REPORTED_PROPERTIES = "GET_ALL_REPORTED_PROPERTIES";
export const GET_REPORTED_PROPERTY_DETAILS = "GET_REPORTED_PROPERTY_DETAILS";

export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_LABELS = "GET_LABELS";
export const GET_LABELS_Name = "GET_LABELS_Name";

export const GET_ALL_CMS = "GET_ALL_CMS";
export const GET_CMS_DETAILS = "GET_CMS_DETAILS";

//department
export const DEPARTMENT_LIST = "DEPARTMENT_LIST";
export const DEPARTMENT_DETAILS = "DEPARTMENT_DETAILS";
//setting get
export const GET_SETTING = "GET_SETTING";
// dashboard
export const GET_DASH_ANALYTICS = "GET_DASH_ANALYTICS";
export const GET_ADMIN_PROPERTIES = "GET_ADMIN_PROPERTIES";

// property Owner
export const GET_ALL_PROP_OWNER = "GET_ALL_PROP_OWNER";
export const GET_OWNER_DETAILS = "GET_OWNER_DETAILS";
export const GET_OWNER_PROPERTIES = "GET_OWNER_PROPERTIES";

// staff support
export const GET_ALL_STAFF_SUPPORT = "GET_ALL_STAFF_SUPPORT";
export const GET_STAFF_SUPPORT_DATA = "GET_STAFF_SUPPORT_DATA";
export const GET_ALL_REPLY = "GET_ALL_REPLY";
export const SUPPORT_STAFF_REPLY = "SUPPORT_STAFF_REPLY";

// email template
export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE";
export const GET_EMAIL_DETAILS = "GET_EMAIL_DETAILS";

// notification
export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";
export const GET_HEADER_NOTIFICATION = "GET_HEADER_NOTIFICATION";
export const GET_UNREAD_NOTIFICATION = "GET_UNREAD_NOTIFICATION";

export const GET_ALL_TESTIMONIALS = "GET_ALL_TESTIMONIALS";
export const GET_TESTIMONIALS_DETAILS = "GET_TESTIMONIALS_DETAILS";

export const GET_ALL_PARTNERS = "GET_ALL_PARTNERS";
export const GET_PARTNERS_DETAILS = "GET_PARTNERS_DETAILS";

// Chats
export const GET_ALL_CHAT = "GET_ALL_CHAT";
export const GET_FIREBASE_MSG = "GET_FIREBASE_MSG";

// property field
export const GET_ALL_PROPERTY_FIELD = "GET_ALL_PROPERTY_FIELD";

export const GET_ALL_AGENCY_RENT = "GET_ALL_AGENCY_RENT";
export const GET_ALL_CONTACT = "GET_ALL_CONTACT";
export const GET_QUESTION_ANSWER = "GET_QUESTION_ANSWER";
export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const GET_ANALYTICS_CARD_DATA = "GET_ANALYTICS_CARD_DATA";
export const GET_TENANT_LIST = "GET_TENANT_LIST";
export const GET_TENANT_DETAILS = "GET_TENANT_DETAILS";

export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const GET_ALL_ADS = "GET_ALL_ADS";
export const GET_UNVERIFIED_TENANT="GET_UNVERIFIED_TENANT";
export const GET_UNVERIFIED_OWNER="GET_UNVERIFIED_OWNER";
export const GET_UNVERIFIED_PROPERTIES="GET_UNVERIFIED_PROPERTIES";
export const GET_ALL_ADVERTISED_PROPERTIES="GET_ALL_ADVERTISED_PROPERTIES";
export const GET_TODO_LIST="GET_TODO_LIST";
export const GET_ADMIN_PROPERTIES_LIST="GET_ADMIN_PROPERTIES_LIST";
export const GET_COMMENT_LIST="GET_COMMENT_LIST";
export const GET_USER_SUBSCRIPTION_HISTORY="GET_USER_SUBSCRIPTION_HISTORY";
export const GET_ALL_CARDS="GET_ALL_CARDS";
export const GET_OWNER_PROPERTIES_ADS="GET_OWNER_PROPERTIES_ADS";
export const GET_OWNER_REPORTED_PROPERTIES="GET_OWNER_REPORTED_PROPERTIES";
export const GET_OWNER_SUBSCRIPTION_INFO="GET_OWNER_SUBSCRIPTION_INFO";
export const GET_OWNER_APPLICATION="GET_OWNER_APPLICATION";
export const GET_OWNER_RENTAL_CONTRACT="GET_OWNER_RENTAL_CONTRACT";
export const GET_OWNER_IP_LIST="GET_OWNER_IP_LIST";
export const GET_USER_SUBSCRIPTION_INFO="GET_USER_SUBSCRIPTION_INFO";
export const GET_SUBSCRIPTION_INFO="GET_SUBSCRIPTION_INFO";
export const GET_TOTAL_INCOME="GET_TOTAL_INCOME";
export const GET_USER_IP_LIST="GET_USER_IP_LIST";
export const GET_RENTAL_CONTRACTS="GET_RENTAL_CONTRACTS"
